import { useEffect, useRef } from "react";

function useAsyncEffect(asyncCallback: (isMounted: () => boolean) => Promise<void>, deps: any[]) {
  const isMounted = useRef(true);

  useEffect(() => {
    // Создаем асинхронную функцию внутри useEffect
    const executeAsync = async () => {
      try {
        await asyncCallback(() => isMounted.current); // Выполняем асинхронный коллбэк
      } catch (error) {
        console.error("Error in useAsyncEffect:", error);
      }
    };

    executeAsync(); // Вызываем асинхронную функцию

    // Дополнительная очистка (если требуется)
    return () => {
      isMounted.current = false;
    };
  }, deps); // Депенденси лист
}

export default useAsyncEffect;
